import React from "react";
import PropTypes from "prop-types";
import PayPalSDKScriptProvider from "./PayPalSDKScriptProvider";
import LegacyPayPalButton from "./LegacyPayPalButton";

const PayPalButtonDisplay = ({
    defaultMessageText = "",
    displayPayPalSDKScriptProvider = false,
    legacyPayPalButtonProps = {},
    payPalSDKScriptProviderProps = {},
}) => {
    if (displayPayPalSDKScriptProvider) {
        return <PayPalSDKScriptProvider {...payPalSDKScriptProviderProps} />;
    }

    // Only display the "You'll be directed to your PayPal account.." text with
    // the Legacy PayPal button as this text comes from CMS in the redesigned
    // Qgiv form, P2P form and events and the new PayPal SDK is set up to also
    // render a Venmo button if Venmo is supported on the user's device
    return (
        <>
            <LegacyPayPalButton {...legacyPayPalButtonProps} />
            <p className="-margin-top--10">{defaultMessageText}</p>
        </>
    );
};

PayPalButtonDisplay.propTypes = {
    displayPayPalSDKScriptProvider: PropTypes.bool.isRequired,
    defaultMessageText: PropTypes.string.isRequired,
    legacyPayPalButtonProps: PropTypes.shape({
        handleButtonClick: PropTypes.func.isRequired,
    }).isRequired,
    payPalSDKScriptProviderProps: PropTypes.shape({
        forceReRender: PropTypes.arrayOf(
            PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
                PropTypes.bool,
            ]).isRequired,
        ).isRequired,
        getDataForCreateOrder: PropTypes.func.isRequired,
        getDataForCreateBillingAgreement: PropTypes.func.isRequired,
        handleCompletePayPalAuthorizationFlow: PropTypes.func.isRequired,
        handleInitiatePayPalAuthorizationFlow: PropTypes.func.isRequired,
        hasAnAmountToSendToPayPal: PropTypes.bool.isRequired,
        isCms: PropTypes.bool.isRequired,
        isRecurringDonation: PropTypes.bool.isRequired,
        payPalScriptProviderOptions: PropTypes.shape({
            "client-id": PropTypes.string.isRequired,
            "merchant-id": PropTypes.string.isRequired,
            "enable-funding": PropTypes.string.isRequired,
            "disable-funding": PropTypes.string.isRequired,
            "data-partner-attribution-id": PropTypes.string.isRequired,
            intent: PropTypes.string.isRequired,
        }).isRequired,
        shouldLoadPayPalSDKScriptProvider: PropTypes.bool.isRequired,
    }).isRequired,
};

export default PayPalButtonDisplay;
